/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrCellKey } from './igr-cell-key';
import { CellKey } from './CellKey';
import { TypeRegistrar } from "igniteui-react-core";
var IgrCellKeyModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrCellKeyModule() {
    }
    IgrCellKeyModule.register = function () {
        TypeRegistrar.registerCons("IgrCellKey", IgrCellKey);
        TypeRegistrar.register("CellKey", CellKey.$type);
    };
    return IgrCellKeyModule;
}());
export { IgrCellKeyModule };
//# sourceMappingURL=igr-cell-key-module.js.map
